import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Grid,
    Chip,
    Divider,
    Paper
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const LogPreviewModal = ({ open, onClose, log }) => {
    if (!log) return null;

    const getStatusColor = (status) => {
        switch (status) {
            case 'Sent':
            case 'Delivered':
                return 'success';
            case 'Failed':
                return 'error';
            default:
                return 'warning';
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Notification Audit Details
                <Chip 
                    label={log.deliveryStatus || log.status} 
                    color={getStatusColor(log.deliveryStatus || log.status)} 
                    size="small" 
                    sx={{ fontWeight: 'bold' }}
                />
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                            SUBJECT / TITLE
                        </Typography>
                        <Typography variant="h6" sx={{ mt: 0.5 }}>{log.title}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                            CHANNEL
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                            {log.channel === 'Email' ? <EmailIcon color="primary" /> : log.channel === 'SMS' ? <SmsIcon color="primary" /> : <NotificationsActiveIcon color="primary" />}
                            <Typography variant="body1">{log.channel}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                            CATEGORY
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 0.5 }}>{log.category || 'System'}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                            MESSAGE PAYLOAD
                        </Typography>
                        <Paper variant="outlined" sx={{ p: 2, mt: 1, bgcolor: 'rgba(0,0,0,0.01)', borderRadius: 2, minHeight: 100 }}>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{log.message}</Typography>
                        </Paper>
                    </Grid>

                    {log.deliveryStatus === 'Failed' && (
                        <Grid item xs={12}>
                            <Typography variant="caption" color="error" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                                ERROR DETAILS
                            </Typography>
                            <Paper variant="outlined" sx={{ p: 2, mt: 1, bgcolor: 'error.50', borderColor: 'error.100', borderRadius: 2 }}>
                                <Typography variant="body2" color="error.main" fontWeight="medium">
                                    {log.errorMessage || 'No specific error message provided by provider.'}
                                </Typography>
                            </Paper>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                            TIMESTAMP
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                            {log.createdAt ? new Date(log.createdAt).toLocaleString('en-US', { 
                                weekday: 'long', 
                                year: 'numeric', 
                                month: 'long', 
                                day: 'numeric', 
                                hour: '2-digit', 
                                minute: '2-digit',
                                second: '2-digit'
                            }) : 'N/A'}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2.5 }}>
                <Button onClick={onClose} variant="contained" sx={{ borderRadius: 2 }}>Close Audit</Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogPreviewModal;
